import { DataPackLine } from './dataPackLine.model';
import { DataPackService } from './DataPackService.model';
import { DataPackValue } from './dataPackValue.model';
import { DataPackUserManagerModel } from './data.manager.model';
import { VoiceConsumptionBatchProcessing } from './voiceConsumptionBatchProcessing.model';

/**
 * @author Wesley Mascarenhas
 * @version $Id: dataPackGroup.model.ts 87745 2018-04-23 22:02:59Z bernardo.d.siqueira $
 */
export class DataPackGroup {

  public id: number;
  public name: string;
  public quota: DataPackValue;
  public unallocatedQuota: DataPackValue;
  public allocateQuota: DataPackValue;
  public quotaConsume: DataPackValue;
  public bonusConsume: DataPackValue;
  public bonus: DataPackValue;
  public extraDataPackConsume: DataPackValue;
  public extraDataPack: DataPackValue;
  public bisConsume: DataPackValue;
  public bis: DataPackValue;
  public percentageConsumedBis: string;
  public percentageConsumedBonus: string;
  public percentageConsumedExtraDataPack: string;
  public percentageConsumedQuota: string;
  public isData: boolean;
  public isSharedBalance:boolean;
  public groupDefault: boolean;
  public manager: DataPackUserManagerModel;
  public lines: Array<DataPackLine> = new Array<DataPackLine>();
  public totalLines: number;
  public totalOfUnidentifiedLines: number;
  public totalOfRowsWithoutQuota: number;
  public totalOfRowsOutOfQuota: number;
  public totalOfRowsOutOflimit: number;
  public totalOfRowsOutOfOverBalancelimit: number;
  public dataNotificationsCount: number;
  public voiceNotificationsCount: number;
  public limit: DataPackValue;
  public consumedLimit: DataPackValue;
  public availableLimit: DataPackValue;
  public overBalanceLimit: DataPackValue;
  public consumedOverBalanceLimit: DataPackValue;
  public availableOverBalance: DataPackValue;
  public percentageConsumedOverBalanceLimit: string;
  public overBalanceLimitNextCycleControll: DataPackValue; //reais
  public overBalanceLocalsLimit: DataPackValue;
  public consumedOverBalanceLocalsLimit: DataPackValue;
  public availableOverBalanceLocalsLimit: DataPackValue;
  public percentageConsumedOverBalanceLocalsLimit: string;
  public overBalanceLocalsLimitNextCycleControll: DataPackValue;
  public overBalanceAllCallsLimit: DataPackValue;
  public consumedOverBalanceAllCallsLimit: DataPackValue;
  public availableOverBalanceAllCalls: DataPackValue;
  public percentageConsumedOverBalanceAllCallsLimit: string;
  public overBalanceAllCallsLimitNextCycleControll: DataPackValue; //minutos
  public availableOverBalanceLocals: DataPackGroup;
  public isErrorGroup :boolean;
  public blockedLDI:boolean = false;
  public blockedOther:boolean = false;
  public facilityDataPackServices = new Array<DataPackService>();
  public groupControlDataPackServices = new Array<DataPackService>();
  public totalLinesWithCallCtrl: string;
  public voiceConsumptionBatchProcessing: VoiceConsumptionBatchProcessing;  //NONE,PENDING,PROCESSED,FINISHED;
  public sucessEditLinesLote:number;
  public errorEditLinesLote:number;
  public technology: string; // Propriedade para armazenar a tecnologia selecionada (4G ou 5G)
  public is5GPortifolio: number;

  public constructor() {

  }
}



// WEBPACK FOOTER //
// ./src/app/models/dataPackGroup.model.ts